import { render, staticRenderFns } from "./singleBlog.vue?vue&type=template&id=4dd866f4&scoped=true"
import script from "./singleBlog.vue?vue&type=script&lang=js"
export * from "./singleBlog.vue?vue&type=script&lang=js"
import style0 from "./singleBlog.vue?vue&type=style&index=0&id=4dd866f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd866f4",
  null
  
)

export default component.exports